import {
    GENERAL_LOGIN_PATH,
    GENERAL_FORGOTTEN_PASSWORD_PATH,
    GENERAL_RESET_PASSWORD_PATH,
    GENERAL_SETTINGS,
    MEMSOURCE_PROJECTS_DETAILS_PATH,
    MEMSOURCE_PROJECTS_LIST_PATH,
    MEMSOURCE_JOBS_LIST_PATH,
    TEMPO_DASHBOARD_PATH,
    TEMPO_PROJECTS_LIST_PATH,
    TEMPO_QUOTES_CREATE_PATH,
    TEMPO_QUOTES_LIST_PATH,
    TEMPO_QUOTES_UPDATE_PATH,
    TEMPO_REPORTING_PATH,
    TEMPO_STUDIES_PATH,
    TEMPO_TERMINOLOGY_PATH,
    TEMPO_VALIDATION_PATH,
    TEMPO_PROJECT_DETAILS_PATH,
    XTRF_PROJECTS_DETAILS_PATH,
    XTRF_PROJECTS_LIST_PATH,
    XTRF_PROJECTS_NEW_PATH,
    XTRF_QUOTE_LIST_PATH,
    XTRF_REPORTS_PATH,
} from './pathList'
import {
    PERMISSION_TEMPO_CREATE_REQUEST,
    PERMISSION_TEMPO_SHOW_PROJECT_LIST,
    PERMISSION_TEMPO_SHOW_REPORTING,
    PERMISSION_TEMPO_TERMINOLOGY,
    PERMISSION_TEMPO_VALIDATE,
} from '../helpers/functions/rolesAndPermissions'
import { Providers } from '../interfaces/Providers'

const routes = [
    {
        path: GENERAL_LOGIN_PATH,
        type: [], // empty === no provider
    },
    {
        path: GENERAL_FORGOTTEN_PASSWORD_PATH,
        type: [],
    },
    {
        path: GENERAL_RESET_PASSWORD_PATH,
        type: [],
    },
    {
        path: GENERAL_SETTINGS,
        type: [Providers.memsource, Providers.xtrf, Providers.tempo],
    },
    {
        path: XTRF_PROJECTS_LIST_PATH,
        type: [Providers.xtrf],
    },
    {
        path: XTRF_REPORTS_PATH,
        type: [Providers.xtrf],
    },
    {
        path: XTRF_PROJECTS_NEW_PATH,
        type: [Providers.xtrf],
    },
    {
        path: XTRF_QUOTE_LIST_PATH,
        type: [Providers.xtrf],
    },
    {
        path: XTRF_PROJECTS_DETAILS_PATH,
        type: [Providers.xtrf],
    },
    {
        path: MEMSOURCE_PROJECTS_LIST_PATH,
        type: [Providers.memsource],
    },
    {
        path: MEMSOURCE_PROJECTS_DETAILS_PATH,
        type: [Providers.memsource],
    },
    {
        path: MEMSOURCE_JOBS_LIST_PATH,
        type: [Providers.memsource],
    },
    {
        path: TEMPO_PROJECTS_LIST_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_SHOW_PROJECT_LIST,
    },
    {
        path: TEMPO_PROJECT_DETAILS_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_SHOW_PROJECT_LIST,
    },
    {
        path: TEMPO_QUOTES_CREATE_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_CREATE_REQUEST,
    },
    {
        path: TEMPO_DASHBOARD_PATH,
        type: [Providers.tempo],
    },
    {
        path: TEMPO_VALIDATION_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_VALIDATE,
    },
    {
        path: TEMPO_TERMINOLOGY_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_TERMINOLOGY,
    },
    {
        path: TEMPO_REPORTING_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_SHOW_REPORTING,
    },
    {
        path: TEMPO_STUDIES_PATH,
        type: [Providers.tempo],
    },
    {
        path: TEMPO_QUOTES_LIST_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_CREATE_REQUEST,
    },
    {
        path: TEMPO_QUOTES_UPDATE_PATH,
        type: [Providers.tempo],
        permission: PERMISSION_TEMPO_CREATE_REQUEST,
    },
]

export default routes
